<template>
  <div>
    <div class="py-1">
      <a :href="link" target="_blank"><div class="record-body float-left width-full">{{text}}</div></a>
      <div class="width-full float-left">
        <div class="float-left text-grey" style="font-size: 12px">{{twitTime}} ({{newsTime}})</div>
        <div class="float-right text-grey" style="font-size: 12px">{{record.data.user.name}}</div>
      </div>
      <div
        class="width-full float-left mb-1"
        style="border-bottom: 1px solid rgba(128, 143, 156, 0.2)"
      ></div>
    </div>
  </div>
</template>

<script>
var moment = require("moment-timezone");
export default {
  name: "NewsItem",
  components: {},
  props: ["record"],
  data() {
    return {
      newsTime: moment(this.record.createdAt).fromNow()
    };
  },
  computed: {
    twitTime(){
      return moment.tz(this.record.createdAt, this.$store.getters.timezone).format("H:mm")
    },
    text() {
      var text = this.record.data.text;
      if (this.record.data.hasOwnProperty("extended_tweet"))
        text = this.record.data.extended_tweet.full_text;
      var lastIndex = text.lastIndexOf(" ");
      if (lastIndex > 0) return text.substring(0, lastIndex);
      else return text;
      //return lastIndex
    },
    link() {
      /*
      var link = ""
      if(this.record.data.is_quote_status){
        link = this.record.data.quoted_status_permalink.url
      }else{
        link = this.record.data.text.split(" ").pop();
      }
      return link
      */
      //return lastIndex
      if(this.record.data.hasOwnProperty("entities")){
        if(this.record.data.entities.hasOwnProperty("urls")){
          if(this.record.data.entities.urls.length > 0)
            return this.record.data.entities.urls[0].url
        }
      }
      return ""
    }
  },
  mounted() {
    this.updateTimes();
    setInterval(() => {
      this.updateTimes();
    }, 1000);
  },
  methods: {
    updateTimes() {
      this.newsTime = moment(this.record.createdAt).fromNow();
    }
  }
};
</script>

<style>
</style>